import { checkAccess } from 'app/actions/app.actions';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { fetchAnnouncements, updateAnnouncements } from 'dashboard/actions/announcements/announcements.actions';
import * as api from 'dashboard/resources/announcements.api';
import template from './announcements-management.html';

const SECOND_HAND_PERMISSION = 'cms.newsManagement.approve';
const DIRTY_FORM = 'announcementsManagement';

const mapStateToThis = ({ session, dirtyForms, config, announcements }) => {
  const { locale } = session;
  const dirtyForm = dirtyForms[DIRTY_FORM];
  const { secondHandApproval, jurisdictionId } = config;
  const { isLoading, draft } = announcements;

  return {
    locale,
    dirtyForm,
    secondHandApproval,
    jurisdictionId,
    isLoading,
    draft,
  };
};

const mapDispatchToThis = {
  fetchAnnouncements,
  updateAnnouncements,
  setDirtyForm,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'Notifications', '$state', 'gettextCatalog', 'Responsive')
class AnnouncementsManagementController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.DIRTY_FORM = DIRTY_FORM;
    this.activeTabIdx = 0;
    this.secondHandApprovalActive = this.checkAccess(SECOND_HAND_PERMISSION);
    if (!this.$state.params.skipReloadData) this.initAnnouncements();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async initAnnouncements() {
    await this.fetchAnnouncements(false);
    this.setDirtyForm(this.DIRTY_FORM, false);
  }

  cancel() {
    this.Notifications.alertSuccess(this.gettextCatalog.getString('Changes have been canceled'));
    return this.initAnnouncements();
  }

  discardChanges() {
    this.setDirtyForm(this.DIRTY_FORM, false);
    return api
      .discardChanges(this.jurisdictionId)
      .then(() => this.Notifications.alertSuccess(this.gettextCatalog.getString('Changes have been discarded')))
      .then(() => this.initAnnouncements());
  }

  publish() {
    this.updateAnnouncements()
      .then(() => this.Notifications.alertSuccess(this.getSuccessText()))
      .then(() => this.initAnnouncements())
      .then(() => this.setDirtyForm(this.DIRTY_FORM, false));
  }

  getSuccessText() {
    return this.secondHandApprovalActive || !this.secondHandApproval
      ? this.gettextCatalog.getString('Changes have been published')
      : this.gettextCatalog.getString('Changes have been submitted for approval');
  }

  isDiscardChangesAvailable() {
    return this.secondHandApproval && this.secondHandApprovalActive && this.draft;
  }

  isSubmitForApprovalAvailable() {
    return this.dirtyForm && this.secondHandApproval && !this.secondHandApprovalActive;
  }

  isPublishAvailable() {
    return (
      (!this.secondHandApproval && this.dirtyForm) ||
      (this.secondHandApproval && this.secondHandApprovalActive && this.draft) ||
      (this.secondHandApproval && this.secondHandApprovalActive && this.dirtyForm)
    );
  }
}

export default class AnnouncementsManagementComponent {
  constructor() {
    this.template = template;
    this.controller = AnnouncementsManagementController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/announcement-management/announcements-management-component.js